import React, {useRef, useState, useEffect} from "react";
import { useDroppable } from "@dnd-kit/core";
import { Rnd } from "react-rnd";
import { useSelector } from "react-redux";
import { BarChart } from "../Charts/BarChart";
// import PieChart from "../Charts/PieChart";
import { LineChart  } from "../Charts/LineChart";
import BarChartWithMarker from "../Charts/BarChartWithMarker"
import StackedBarChart from "../Charts/StackedBarChart"
import Multi_Line_chart from "../Charts/MultiAxisLineChart"
import PieChart from "../Charts/PieChart";
import TableChart from "../Charts/TableChart";
import AreaChart from "../Charts/AreaChart";
import Range_Bar_Chart from "../Charts/Range_Bar_Chart";
import HeatChart from "../Charts/HeatChart";
import SimpleDonutChart from "../Charts/SimpleDonutChart";
import LineBarChart from "../Charts/LineBarChart";
import ScatterChart from "../Charts/ScatterChart";
import HorizontalBarChart from "../Charts/HorizontalBarChart";


const Canvas = ({ components, addComponent, removeComponent, updateComponent }) => {
  const { setNodeRef } = useDroppable({ id: "canvas" });
  const {dnd_components} = useSelector((state)=>state.Dashboard)
  
// testing
const canvasRef = useRef(null);
const [canvasSize, setCanvasSize] = useState({ width: 0, height: 0 });

useEffect(() => {
  const updateCanvasSize = () => {
    if (canvasRef.current) {
      setCanvasSize({
        width: canvasRef.current.offsetWidth,
        height: canvasRef.current.offsetHeight,
      });
    }
  };

  updateCanvasSize(); // initial
  window.addEventListener("resize", updateCanvasSize);
  return () => window.removeEventListener("resize", updateCanvasSize);
}, []);

  return (
    
    <div
       ref={(node) => {
        setNodeRef(node);
        canvasRef.current = node;
      }}
      id="canvas-zone"
      className="relative display_component_area web_visible"
    >
      
      {dnd_components.map((comp) => {
        // Safe defaults to avoid null/undefined issues
        // const width = comp.width || 600;
        // const height = comp.height || 400;
        // const x = comp.x ?? 0;
        // const y = comp.y ?? 0;
        // const data = comp.data
        const widthPercent = comp.widthPercent || 33;
        const heightPercent = comp.heightPercent || 40;

          const width = (canvasSize.width * widthPercent) / 100;
          const height = (canvasSize.height * heightPercent) / 100;
          console.log(comp, "X Y values relative ")
                  // 3. Use relative x/y percent if available, else fallback to 0
          const xPercent = comp.xPercent ?? comp.x ?? 0;
          const yPercent = comp.yPercent ?? comp.y ?? 0;

          // 4. Convert percent to actual pixel coordinates
          const x = (canvasSize.width * xPercent) / 100;
          const y = (canvasSize.height * yPercent) / 100;


          const data = comp.data;

        return (
          <Rnd
            // key={comp.id}
            // size={{ width, height }}
            // position={{ x, y }}
            // bounds="parent"
            // minWidth={350}
            // minHeight={250}            
            // onDragStop={(e, d) =>
            //   updateComponent(comp.id, { x: d.x, y: d.y })
            // }
            // onResize={(e, dir, ref, delta, position) => {
            //   updateComponent(comp.id, {
            //     width: ref.offsetWidth,
            //     height: ref.offsetHeight,
            //     ...position,
                 
            //   });
            // }}
            key={comp.id}
            size={{ width, height }}
            position={{ x, y }}
            bounds="parent"
            minWidth={canvasSize.width * 0.3} // 30% min width
            minHeight={canvasSize.height * 0.25}
            onDragStop={(e, d) =>{
              const xPercent = (d.x / canvasSize.width) * 100;
              const yPercent = (d.y / canvasSize.height) * 100;
              console.log("Values of x , y", xPercent, yPercent)
              updateComponent(comp.id, { x: d.x, y: d.y , xPercent , yPercent })
            }
            }
            onResize={(e, dir, ref, delta, position) => {
            const newWidthPx = ref.offsetWidth;
            const newHeightPx = ref.offsetHeight;

            const newWidthPercent = (newWidthPx / canvasSize.width) * 100;
            const newHeightPercent = (newHeightPx / canvasSize.height) * 100;

            updateComponent(comp.id, {
              widthPercent: newWidthPercent,
              heightPercent: newHeightPercent,
              ...position,
            });
          }}
            
              onMouseDown={(e) => {
                // Check if the click is outside the table
                const isInTable = e.target.closest("div.tableNoDrag");
                if (!isInTable) {
                  updateComponent(comp.id, { dragging: true });
                } else {
                  updateComponent(comp.id, { dragging: false });
                }
              }}
              dragHandleClassName={comp.dragging ? undefined : 'no-drag'}
              className={`chart_wrap absolute p-2 rounded-xl border-2 ${
              comp.type === "bar"
                ? "border-blue-500"
                : comp.type === "pie"
                ? "border-purple-500"
                : comp.type === "line"
                ? "border-green-500"
                : comp.type === "table"
                ? "border-green-500"
                : comp.type === "bar_with_marker"
                ? "border-green-500"
                : comp.type === "bar_with_stacked"
                ? "border-green-500"
                : comp.type === "area_chart"
                ? "border-green-500"
                : comp.type === "SimpleDonutChart"
                ? "border-green-500"
                : "border-gray-500"
            } bg-white bg-dark hover:ring-2 hover:ring-offset-2 hover:ring-blue-300`}
          >
            
            <div className="flex justify-between items-center mb-1">
              <span className="font-semibold capitalize text-sm text-gray-700">
                {comp.title}
              </span>
              <button
                onClick={() => removeComponent(comp.id)}
                className="text-red-500 text-xs hover:text-red-700"
              >
                <i className="ri-close-circle-line"></i>
              </button>
            </div>
            {console.log("Type of Data",comp.type)}
            
            <div className="h-full w-full flex items-center justify-center text-gray-400 text-xs bg-gray-50 rounded table-overflow">
              {comp.type === "bar" && (
                <BarChart data={data?.formatted_data_for_visualization} width={width * 0.95} height={height * 0.9} />
              )}
              {comp.type === "pie" && (
                <PieChart data={data?.formatted_data_for_visualization} width={width * 0.95} height={height * 0.8} />
              )}
              {comp.type === "line" && (
                <LineChart data={data?.formatted_data_for_visualization}  width={width * 0.96} height={height * 0.8} />
              )}
              {comp.type === null || comp.type === 'none' && (                
                  <div className="tableNoDrag">
                    <TableChart  data={data} height={height * 0.8} width={width * 0.95 }/>
                  </div>               
              )}
              {comp.type === "bar_with_marker" && (                
                  <div className="tableNoDrag">
                    <BarChartWithMarker  data={data?.formatted_data_for_visualization} width={width * 0.8} height={height * 0.8}/>
                  </div>               
              )}
              {comp.type === "bar_with_stacked" && (                
                  <div className="tableNoDrag">
                    <StackedBarChart  data={ data?.formatted_data_for_visualization? JSON.parse(JSON.stringify(data?.formatted_data_for_visualization)) : null } width={width * 0.8} height={height * 0.8}/>
                  </div>               
              )}
              {comp.type === "multi_axis_line_chart" && (                
                  <div className="tableNoDrag">
                    <Multi_Line_chart  data={JSON.parse(JSON.stringify(data?.formatted_data_for_visualization))} width={width * 0.8} height={height * 0.8}/>
                  </div>               
              )}
              {comp.type === "area_chart" && (                
                  <div className="tableNoDrag">
                    <AreaChart  data={JSON.parse(JSON.stringify(data?.formatted_data_for_visualization))} width={width * 0.8} height={height * 0.8}/>
                  </div>               
              )}
              {comp.type === "range_bar" && (                
                  <div className="tableNoDrag">                    
                    <Range_Bar_Chart  data={JSON.parse(JSON.stringify(data?.formatted_data_for_visualization))} width={width * 0.8} height={height * 0.8}/>
                  </div>               
              )}
              {comp.type === "heatmap" && (                
                  <div className="tableNoDrag">                     
                    <HeatChart  width={width * 0.8} height={height * 0.8}/>
                  </div>               
              )}
              {comp.type === "SimpleDonutChart" && (                
                  <div className="tableNoDrag">                     
                    <SimpleDonutChart  width={width * 0.8} height={height * 0.8}/>
                  </div>               
              )}
              {comp.type === "LineBarChart" && (                
                  <div className="tableNoDrag">                     
                    <LineBarChart  width={width * 0.8} height={height * 0.8}/>
                  </div>               
              )}
              {comp.type === "ScatterChart" && (                
                  <div className="tableNoDrag">                     
                    <ScatterChart  width={width * 0.8} height={height * 0.8}/>
                  </div>               
              )}
              {comp.type === "HorizontalBarChart" && (                
                  <div className="tableNoDrag">                     
                    <HorizontalBarChart  width={width * 0.8} height={height * 0.8}/>
                  </div>               
              )}              
            </div>
          </Rnd>
        );
      })}
    </div>
  );
};

export default Canvas;
